export enum SemanticColor {
  default = 'default',
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
}

export enum RGBColor {
  default = 'rgb(212, 212, 216)',
  primary = 'rgb(0, 111, 238)',
  secondary = 'rgb(143, 87, 211)',
  success = 'rgb(23, 201, 100)',
  warning = 'rgb(245, 165, 36)',
  danger = 'rgb(245, 65, 128)',
}

export enum HexColor {
  default = '#D4D4D8',
  primary = '#006FEE',
  secondary = '#8F57D3',
  success = '#17C964',
  warning = '#F5A524',
  danger = '#F54141',
  cancel = '#171918',
}

export enum AlphaColor {
  default = 'rgba(212, 212, 216, 0.2)',
  primary = 'rgba(0, 111, 238, 0.2)',
  secondary = 'rgba(143, 87, 211, 0.2)',
  success = 'rgba(23, 201, 100, 0.2)',
  warning = 'rgba(245, 165, 36, 0.2)',
  danger = 'rgba(245, 65, 128, 0.2)',
  cancel = 'rgba(23, 25, 24, 0.2)',
}
